// extracted by mini-css-extract-plugin
export default {"container":"MainHeader_container__iNEPj","logo":"MainHeader_logo__XONcY","profile_btn":"MainHeader_profile_btn__b23Dh","profile_name":"MainHeader_profile_name__Iah4k"};